import { FreeSpin } from '../services/RewardsService.schemas';

export function mergeFreeSpins(freeSpins: FreeSpin[]) {
  const merged: FreeSpin[] = [];

  for (const item of freeSpins) {
    const gameKey = item.games[0].id;

    const existing = merged.find((entry) => entry.games[0].id === gameKey);

    if (existing) {
      existing.totalFreeSpinsCount += item.totalFreeSpinsCount;
      existing.freeSpinsLeft += item.freeSpinsLeft;

      if (new Date(item.rewardedAt) > new Date(existing.rewardedAt)) {
        existing.rewardedAt = item.rewardedAt;
      }
    } else {
      merged.push({ ...item });
    }
  }

  return merged.sort(
    (a, b) =>
      new Date(b.rewardedAt).getTime() - new Date(a.rewardedAt).getTime(),
  );
}
